import { lazy }  from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import { useCheckAccess } from "./hooks/useCheckAccess";
import { store } from './store.js'
import Loadable from "./General/Loadable.jsx";
import { setEntry } from "./EntryHelpers/setEntry.js";
import { getElemApp } from "./EntryHelpers/getElems.js";
import { useRootCssVars } from "./hooks/useRootCssVars.js";

const PortalSubpage = Loadable(lazy(() => import('./PortalSubpage/PortalSubpage.jsx')))
const PortalSubpageAccess = Loadable(lazy(() => import('./PortalSubpage/PortalSubpageAccess.jsx')))

const AccessWrapperSubpage = ({isMobile, isWebApp}) => {
    const useAccesTheme = useCheckAccess()
    useRootCssVars(useAccesTheme)

    if(useAccesTheme) {
        return <PortalSubpageAccess />
    } else {
        return <PortalSubpage
            isMobile={isMobile}
            isWebApp={isWebApp}
        />
    }
}

const elemApp = getElemApp()

if(elemApp) {
    const [isWebApp, isMobile] = setEntry()

    ReactDOM.render(<Provider store={store}><AccessWrapperSubpage isMobile={isMobile} isWebApp={isWebApp} /></Provider>, elemApp)
}
